<template>
  <v-row no-gutters>
    <v-col>
      <v-select
        v-if="isEditing"
        v-model="quizContent"
        :disabled="disabled || loading"
        background-color="transparent"
        flat
        full-width
        hide-details="auto"
        outlined
        :hint="label || $t('quiz.quiz')"
        persistent-hint
        dense
        :readonly="!isEditing"
        :items="quizContents"
        item-value="_id"
        :item-text="item => getLocalisedValue(item.title)"
        :return-object="returnObject"
        :error-messages="warningMessage"
        class="rounded-2"
        :class="cssWarningClass"
      >
        <template v-slot:item="{ item }">
          <div class="d-flex justify-start">
            {{ getLocalisedValue(item.title) }}
          </div>
        </template>

        <template v-if="quizContents.length < totalCount" v-slot:append-item>
          <div v-if="infiniteLoading" class="px-4 pb-2">
            <v-progress-linear indeterminate></v-progress-linear>
          </div>

          <div v-else v-intersect="onLoadMore"></div>
        </template>
      </v-select>

      <span v-else class="text-break" :class="cssClass">
        {{ `${label}: ${labelValue || "-"}` }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import { doQuery } from "@/app/core-module/util/graphqlHelper";

export default {
  name: "QuizDropDown",
  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: true,
    },
    label: null,
    isEditing: {
      type: Boolean,
      default: false,
    },
    cssClass: String,
    hasWarning: {
      type: Boolean,
      default: false,
    },
    warningMessage: String,
  },
  data() {
    return {
      loading: true,
      infiniteLoading: false,
      hasLoadingError: false,
      pageInput: this.defaultPageInput(),
      quizContents: [],
      totalCount: [],
    };
  },
  computed: {
    quizContent: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    cssWarningClass() {
      return this.hasWarning ? "warning--text text-field-warning-border" : "";
    },
    labelValue() {
      if (this.value?.title) return this.getLocalisedValue(this.value.title);

      return this.getLocalisedValue(
        this.quizContents.find(x => x._id === this.value?._id)?.title
      );
    },
  },
  created() {
    this.getQuizContents();
  },
  methods: {
    getQuizContents() {
      return doQuery({
        query: require("../api/query/getQuizContents.gql"),
        variables: {
          pageInput: this.pageInput,
          filterInput: { approvalStatus: "APPROVED", isActive: true },
        },
      }).then(({ data }) => {
        if (data?.getQuizContents?.quizContents) {
          for (const item of data.getQuizContents.quizContents) {
            if (this.quizContents.findIndex(x => x._id === item._id) < 0) {
              this.quizContents.push(item);
            }
          }

          this.totalCount =
            data.getQuizContents.totalCount ?? this.quizContents.length;
        } else {
          this.hasLoadingError = true;
        }

        if (this.pageInput.skip === 0) this.loading = false;
        else this.infiniteLoading = false;
      });
    },
    onLoadMore(_, __, isIntersecting) {
      if (!this.loading && !this.infiniteLoading && isIntersecting) {
        this.infiniteLoading = true;
        this.pageInput.skip += this.pageInput.limit;
        this.getQuizContents();
      }
    },
  },
};
</script>
